var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"banner",staticClass:"banner",style:({backgroundImage: 'url('+_vm.bannerUrl+')', height: _vm.bannerHeight})},[_vm._t("searchBox"),_vm._t("sideNav")],2)}
var staticRenderFns = []

export { render, staticRenderFns }